<template>
  <div class="search">
    <i-search class="search__button" :color="'#c2c2d6'" :size="20" />
    <input
      @input="$emit('search', message)"
      v-model="message"
      :placeholder="$t('calendar.header.search')"
      class="search__form"
      type="search"
      autocomplete="off"
    />
    <span class="search__close" v-if="message !== ''">
      <i-close-circle @click.native="clearInput"></i-close-circle>
    </span>
  </div>
</template>

<script>
import isearch from '@/components/icons/search'
import iclosecircle from '@/components/icons/closecircle'

export default {
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      message: this.value || '',
    }
  },
  watch: {
    value(value) {
      this.message = value
    },
  },
  methods: {
    clearInput() {
      this.message = ''
      this.$emit('search', this.message)
    },
  },
  components: {
    'i-search': isearch,
    'i-close-circle': iclosecircle,
  },
}
</script>

<style lang="scss">
.search {
  display: inline-flex;
  max-width: 202px;
  border: 1px solid #eaeaf5;
  border-radius: 4px;
  position: relative;

  &__button {
    width: 32px;
    border-right: 1px solid #c2c2d6;
    margin: auto 0;
  }
  &__form {
    width: calc(80% - 20px);
    margin-left: 4px;
    border: none;
    line-height: 29px;

    &::placeholder {
      color: #9d9dbc;
    }
    &::-webkit-search-cancel-button {
      display: none;
    }
  }
  &__close {
    position: absolute;
    top: -2px;
    right: 2px;
  }

  @media (max-width: 576px) {
    height: 28px;
    max-width: initial;
    width: 100%;

    &__button {
      border-right: 1px solid #c2c2d6;
      margin: auto 3px;
    }
    &__form {
      width: calc(90% - 34px);
    }
    &__close {
      top: -4px;
      right: 4px;
    }
  }
}

.calendar {
  .search {
    @media (max-width: 767px) {
      margin-right: 0;
    }
  }
}

.ideas__filters {
  .search {
    &__form {
      line-height: 30px;
    }
    &__close {
      top: auto;
      right: 6px;
    }

    @media (max-width: 767px) {
      max-width: 100%;
      width: 100%;
      margin-right: 8px;
      &__close {
        top: 0px;
      }
    }
    @media (max-width: 576px) {
      &__close {
        top: -4px;
      }
    }
  }
}

#app[data-theme='dark'] {
  .search {
    &__form {
      background: inherit;
      color: inherit;
    }
  }
}
</style>
